import React, {AnchorHTMLAttributes} from 'react'

function Link({href, children}: AnchorHTMLAttributes<HTMLAnchorElement>) {
	return (
		<a
			className="
				m-5 px-10 py-5
				bg-pulse-blue rounded-full
				leading-5 text-sm text-white tracking-[1px] uppercase
				cursor-pointer
				hover:opacity-80"
			href={href}
		>
			{children}
		</a>
	)
}

function App() {
	return (
		<div className="flex flex-col min-h-screen items-center justify-center p-5">
			<img
				alt="Protect Group"
				className="h-full w-1/2 object-cover mt-5"
				src="/logo.png"
			/>
			<h1 className="mt-5 text-6xl text-pulse-blue">React Component Test App</h1>
			<div className="flex flex-row justify-between mt-5">
				<Link href="/protect-plus">Protect Plus</Link>
				<Link href="/refundable">Refundable</Link>
			</div>
		</div>
	)
}

export default App
